import { UIComponent } from "@aptus/frontend-core";
import { AutoCompleteSelect } from "components/form/autoCompleteSelect/autoCompleteSelect";
import { ClassificationSelectProps, useClassificationSelect } from "./useClassificationSelect";

export const ClassificationSelect: UIComponent<ClassificationSelectProps> = (props) => (
	<AutoCompleteSelect {...useClassificationSelect(props)} />
);
